import identify from './identify'
import format from './format'
import definitionByLabel from './definitionByLabel'

export default {
  identify,
  format,
  definitionByLabel,
}
